export const RESUMEN_PEDIDO_DRAWER_WIDTH = 365
